import React, { useState, useEffect } from 'react';
import { Grid, TextField, Typography, CardContent, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useEvents } from 'hooks';
import GeometryFileImport from 'components/upload/GeometryFileImport';

const FertilizeFieldInput = () => {
  const { t } = useTranslation();
  const { setPlan, farmerPlan } = useEvents();
  const [geometry, setGeometry] = useState({ name: '' });

  const [acreUnit] = useState('acres');
  const [rateUnit] = useState('lb/ac');
  const [fertilizerNameFormat] = useState('fertilizer_name');
  const [fertilizerFormat] = useState('N-P-K');
  const [fertilizerNameExample] = useState('Ammonium Sulphate');
  const [fertilizerExample] = useState('30-0-5');

  useEffect(() => {
    setPlan({
      data: {
        ...farmerPlan.data,
        geometry: geometry,
      },
    });
  }, [geometry]);

  const handleAcreageChange = (event) => {
    setPlan({
      data: {
        ...farmerPlan.data,
        acreage: event.target.value,
        geometry: geometry,
      },
    });
  };

  const handleRateChange = (event) => {
    setPlan({
      data: {
        ...farmerPlan.data,
        rate: event.target.value,
        geometry: geometry,
      },
    });
  };

  const handleFertilizerNameChange = (event) => {
    setPlan({
      data: {
        ...farmerPlan.data,
        fertilizer_name: event.target.value,
        geometry: geometry,
      },
    });
  };

  const handleFertilizerGradeChange = (event) => {
    setPlan({
      data: {
        ...farmerPlan.data,
        fertilizer_grade: event.target.value,
        geometry: geometry,
      },
    });
  };

  return (
    <div>
      <CardContent>
        <Typography variant="h6">{t('fertilize_information')}</Typography>
      </CardContent>
      <Grid container>
        <Grid item container direction="row" alignItems="center" xs={12} sm={8} padding={2}>
          <Grid item sm={6}>
            <TextField
              id="acreage"
              label={t('acreage')}
              value={farmerPlan?.data?.acreage}
              placeholder="0"
              onChange={handleAcreageChange}
              type="number"
            />
          </Grid>
          <Grid item sm={2}>
            <Typography style={{ marginLeft: '12px' }} variant="subtitle1" gutterBottom component="div">
              {t(acreUnit)}
            </Typography>
          </Grid>
        </Grid>

        <Grid item container direction="row" alignItems="center" xs={12} sm={8} padding={2}>
          <Grid item sm={6}>
            <TextField
              id="rate"
              label={t('rate')}
              value={farmerPlan?.data?.rate}
              placeholder="0"
              onChange={handleRateChange}
              type="number"
            />
          </Grid>
          <Grid item sm={2}>
            <Typography style={{ marginLeft: '12px' }} variant="subtitle1" gutterBottom component="div">
              {rateUnit}
            </Typography>
          </Grid>
        </Grid>

        <Grid item container direction="row" alignItems="center" xs={12} sm={8} padding={2}>
          <Grid item sm={6}>
            <TextField
              id="fertilizer_name"
              label={t('fertilizer_name')}
              value={farmerPlan?.data?.fertilizer_name}
              placeholder={fertilizerNameExample}
              onChange={handleFertilizerNameChange}
            />
          </Grid>
          <Grid item sm={2}>
            <Typography style={{ marginLeft: '12px' }} variant="subtitle1" gutterBottom component="div">
              {t(fertilizerNameFormat)}
            </Typography>
          </Grid>
        </Grid>

        <Grid item container direction="row" alignItems="center" xs={12} sm={8} padding={2}>
          <Grid item sm={6}>
            <Tooltip title="Please Format As X-Y-Z" arrow>
              <TextField
                id="fertilizer_grade"
                label={t('fertilizer_grade')}
                value={farmerPlan?.data?.fertilizer_grade}
                placeholder={fertilizerExample}
                onChange={handleFertilizerGradeChange}
              />
            </Tooltip>
          </Grid>
          <Grid item sm={2}>
            <Typography style={{ marginLeft: '12px' }} variant="subtitle1" gutterBottom component="div">
              {fertilizerFormat}
            </Typography>
          </Grid>
        </Grid>
        <Grid item container direction="row" alignItems="center" xs={12} sm={8} padding={2}>
          <GeometryFileImport geometry={geometry} setGeometry={setGeometry} />
        </Grid>
      </Grid>
    </div>
  );
};

FertilizeFieldInput.propTypes = {};

export default FertilizeFieldInput;
